let fadeInQueued = false

window.addEventListener("scroll", queueFadeIn, { passive: true })

function queueFadeIn() {
  if (fadeInQueued) return
  fadeInQueued = true
  window.requestAnimationFrame(() => {
    fadeInQueued = false
    fadeIn()
  })
}

function fadeIn() {
  let elementsArray = document.querySelectorAll(".animate:not(.animated)")
  let windowHeight = window.innerHeight
  for (var i = 0; i < elementsArray.length; i++) {
    var elem = elementsArray[i]
    var distInView = elem.getBoundingClientRect().top - windowHeight + 100
    if (distInView < 0) {
      elem.classList.add("animated")
    }
  }
}
fadeIn()
